import { computed } from 'vue'
import assembleKaiaAppDeepLink from '@shared/helpers/assembleKaiaAppDeepLink.js'
import useSharedStore from '@shared/stores/useSharedStore.js'

const DEEP_LINK_TTL_MS = 30_000

export const DEEP_LINK_CONFIGS = {
  activationProgress: {
    path: 'goto/screen',
    query: { target: 'activation_progress' },
    addOneTimeAuthToken: true,
    fallback: () => assembleKaiaAppDeepLink({ path: 'open' }),
  },
  authToken: {
    path: 'auth/one_time_token',
    addOneTimeAuthToken: true,
    fallback: () =>
      assembleKaiaAppDeepLink({
        path: 'goto/screen',
        query: { target: 'login' },
      }),
  },
}

export default function useDeepLink(config) {
  const sharedStore = useSharedStore()
  const redirectLink = computed(() => sharedStore.redirectLink)

  const getDeepLink = async () => await assembleKaiaAppDeepLink(config)

  const ensureDeepLink = async () => {
    if (redirectLink.value?.creationDate > Date.now() - DEEP_LINK_TTL_MS) {
      return
    }

    const link = await getDeepLink()
    sharedStore.redirectLink = { link, creationDate: Date.now() }
  }

  const redirect = async () => {
    await ensureDeepLink()
    window.location.redirectToDeeplink(redirectLink.value.link)
  }

  return {
    redirectLink,
    getDeepLink,
    ensureDeepLink,
    redirect,
  }
}
